(() => {
  'use strict';

  const config = document.getElementById('BagoContentProtection');
  const root = document.documentElement;
  if (!config || root.hasAttribute('data-bago-copy-protection')) return;

  const protectText = config.dataset.protectText === 'true';
  const protectMenu = config.dataset.protectMenu === 'true';
  const protectImages = config.dataset.protectImages === 'true';
  if (!protectText && !protectMenu && !protectImages) return;

  root.setAttribute('data-bago-copy-protection', '');
  if (protectText) root.setAttribute('data-bago-protect-text', '');
  if (protectImages) root.setAttribute('data-bago-protect-images', '');

  const allowedSelector = 'input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="textbox"], [data-bago-allow-copy], a[href^="mailto:"], a[href^="tel:"]';
  const elementFor = (node) => node instanceof Element ? node : node?.parentElement;
  const allowedNode = (node) => Boolean(elementFor(node)?.closest(allowedSelector));
  const allowedEvent = (event) => {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    return path.some(allowedNode);
  };
  const allowedSelection = () => {
    const selection = window.getSelection();
    return Boolean(selection && !selection.isCollapsed && allowedNode(selection.anchorNode) && allowedNode(selection.focusNode));
  };
  const prevent = (event) => {
    if (event.cancelable) event.preventDefault();
  };

  if (protectText) {
    const protectClipboard = (event) => {
      if (!allowedEvent(event) && !allowedSelection()) prevent(event);
    };
    document.addEventListener('copy', protectClipboard, true);
    document.addEventListener('cut', protectClipboard, true);
    document.addEventListener('selectstart', (event) => {
      if (!allowedEvent(event)) prevent(event);
    }, true);
    document.addEventListener('keydown', (event) => {
      if (allowedEvent(event) || event.altKey || !(event.ctrlKey || event.metaKey)) return;
      const key = event.key.toLowerCase();
      if ((key === 'c' || key === 'x') && allowedSelection()) return;
      if (key === 'a' || key === 'c' || key === 'x') prevent(event);
    }, true);
  }

  if (protectMenu) {
    document.addEventListener('contextmenu', (event) => {
      if (!allowedEvent(event)) prevent(event);
    }, true);
  }

  if (protectImages) {
    document.addEventListener('dragstart', (event) => {
      if (allowedEvent(event)) return;
      if (elementFor(event.target)?.closest('img, picture')) prevent(event);
    }, true);
  }
})();
